<template>
  <div class="result-ring">
    <div class="progress-circle" :style="{ width: size + 'px', height: size + 'px' }">
      <!-- Use a div with background-color for the outer ring -->
      <div class="outer-ring" :style="{
        backgroundColor: colorValue,
        borderRadius: '50%',
        width: size + 'px',
        height: size + 'px'
      }">
        <!-- White inner circle -->
        <div class="inner-circle" :style="{
          width: (size * 0.75) + 'px',
          height: (size * 0.75) + 'px',
          marginTop: (size * 0.125) + 'px',
          marginLeft: (size * 0.125) + 'px'
        }">
          <span class="percentage" :style="{
            fontSize: (size / 4.5) + 'px'
          }">{{ isNaN(percentage) ? 'N/A' : percentage + '%' }}</span>
        </div>
      </div>
    </div>
    <h3>{{ category }}</h3>
    <p><span v-html="message"></span></p>
  </div>
</template>

<script>
export default {
  props: {
    category: {
      type: String,
      required: true
    },
    score: {
      type: Number,
      required: true
    },
    weights: {
      type: Object,
      default: () => ({})
    },
    size: {
      type: Number,
      default: 90
    }
  },
  data() {
    return {
      colorRanges: [
        { max: 70, color: 'red' },
        { max: 75, color: 'light-orange' },
        { max: 80, color: 'orange' },
        { max: 85, color: 'light-green' },
        { max: 99, color: 'medium-green' },
        { max: 100, color: 'dark-green' }
      ],
      categoryMessages: {
        "Food Safety": [
          { max: 70, text: "There's Food Safety work to be done! <br><a href='/storesafe/' target='_blank'>Find all the Cambro product solutions you need here.</a>" },
          { max: 75, text: "There's still room to perfect your Food Safety craft. <br><a href='/storesafe/' target='_blank'>Find the Cambro product solutions you need here.</a>" },
          { max: 80, text: "You're doing good. <br><a href='/storesafe/' target='_blank'>See what it takes to be GREAT using these Cambro product solutions.</a>" },
          { max: 85, text: "You're almost there! <br><a href='/storesafe/' target='_blank'>Fill in your Food Safety gaps with these Cambro product solutions.</a>" },
          { max: 99, text: "Your Food Safety practices are pretty darn good, huh? But not perfect! <br><a href='/storesafe/' target='_blank'>See what it takes to score 100% here.</a>" },
          { max: 100, text: "Simply perfect!" }
        ],
        "Cost Savings": [
          { max: 70, text: "There's work to be done! <br><a href='/storesafe/' target='_blank'>Find all the Cambro product solutions you need here.</a>" },
          { max: 75, text: "There's still room to improve your Cost Savings. <br><a href='/storesafe/' target='_blank'>Find the Cambro product solutions you need here.</a>" },
          { max: 80, text: "You're doing good. <br><a href='/storesafe/' target='_blank'>See what it takes to be GREAT using these Cambro product solutions.</a>" },
          { max: 85, text: "You're almost there! <br><a href='/storesafe/' target='_blank'>Fill in your Cost Savings gaps with these Cambro product solutions.</a>" },
          { max: 99, text: "Your Cost Savings practices are pretty darn good, huh? But not perfect! <br><a href='/storesafe/' target='_blank'>See what it takes to score 100% here.</a>" },
          { max: 100, text: "Simply perfect!" }
        ],
        "Labor Efficiency": [
          { max: 70, text: "There's work to be done! <br><a href='/storesafe/' target='_blank'>Find all the Cambro product solutions you need here.</a>" },
          { max: 75, text: "There's still room to improve your Labor Efficiency. <br><a href='/storesafe/' target='_blank'>Find the Cambro product solutions you need here.</a>" },
          { max: 80, text: "You're doing good. <br><a href='/storesafe/' target='_blank'>See what it takes to be GREAT using these Cambro product solutions.</a>" },
          { max: 85, text: "You're almost there! <br><a href='/storesafe/' target='_blank'>Fill in your Labor Efficiency gaps with these Cambro product solutions.</a>" },
          { max: 99, text: "Your Labor Efficiency practices are pretty darn good, huh? But not perfect! <br><a href='/storesafe/' target='_blank'>See what it takes to score 100% here.</a>" },
          { max: 100, text: "Simply perfect!" }
        ],
        "Space Optimization": [
          { max: 70, text: "There's work to be done! <br><a href='/storesafe/' target='_blank'>Find all the Cambro product solutions you need here.</a>" },
          { max: 75, text: "There's still room to improve your Space Optimization. <br><a href='/storesafe/' target='_blank'>Find the Cambro product solutions you need here.</a>" },
          { max: 80, text: "You're doing good. <br><a href='/storesafe/' target='_blank'>See what it takes to be GREAT using these Cambro product solutions.</a>" },
          { max: 85, text: "You're almost there! <br><a href='/storesafe/' target='_blank'>Fill in your Space Optimization gaps with these Cambro product solutions.</a>" },
          { max: 99, text: "Your Space Optimization practices are pretty darn good, huh? But not perfect! <br><a href='/storesafe/' target='_blank'>See what it takes to score 100% here.</a>" },
          { max: 100, text: "Simply perfect!" }
        ],
        "Sustainability": [
          { max: 70, text: "There's work to be done! <br><a href='/storesafe/' target='_blank'>Find all the Cambro product solutions you need here.</a>" },
          { max: 75, text: "There's still room to improve your Sustainability efforts. <br><a href='/storesafe/' target='_blank'>Find the Cambro product solutions you need here.</a>" },
          { max: 80, text: "You're doing good. <br><a href='/storesafe/' target='_blank'>See what it takes to be GREAT using these Cambro product solutions.</a>" },
          { max: 85, text: "You're almost there! <br><a href='/storesafe/' target='_blank'>Fill in your Sustainability gaps with these Cambro product solutions.</a>" },
          { max: 99, text: "Your Sustainability practices are pretty darn good, huh? But not perfect! <br><a href='/storesafe/' target='_blank'>See what it takes to score 100% here.</a>" },
          { max: 100, text: "Simply perfect!" }
        ],
        "Total Score": [
          { max: 70, text: "There's work to be done! <br><a href='/storesafe/' target='_blank'>Find all the Cambro product solutions you need here.</a>" },
          { max: 75, text: "There's still room to improve. <br><a href='/storesafe/' target='_blank'>Find the Cambro product solutions you need here.</a>" },
          { max: 80, text: "You're doing good. <br><a href='/storesafe/' target='_blank'>See what it takes to be GREAT using these Cambro product solutions.</a>" },
          { max: 85, text: "You're almost there!" },
          { max: 99, text: "Your practices are pretty darn good, huh? But not perfect! <br><a href='/storesafe/' target='_blank'>See what it takes to score 100% here.</a>" },
          { max: 100, text: "Simply perfect!" }
        ]
      }
    };
  },
  computed: {
    weightedScore() {
      return this.score;
    },
    percentage() {
      return isNaN(this.score) ? 0 : Math.round(this.score);
    },
    colorClass() {
      const range = this.colorRanges.find(range => this.score <= range.max);
      return range ? range.color : 'dark-green';
    },
    colorValue() {
      // Convert color class to CSS color
      const colorMap = {
        'red': '#e40000',
        'light-orange': '#e35b00',
        'orange': '#e28b00',
        'light-green': '#bfa005',
        'medium-green': '#7ea20e',
        'dark-green': '#00a213'
      };
      return colorMap[this.colorClass] || '#00a213';
    },
    message() {
      const categorySpecificMessages = this.categoryMessages[this.category] || this.categoryMessages["Total Score"];
      if (!categorySpecificMessages) {
        console.warn(`No messages found for category: ${this.category}`);
        return "Category not recognized";
      }
      const messageObj = categorySpecificMessages.find(msg => this.weightedScore <= msg.max);
      return messageObj ? messageObj.text : "Simply perfect!";
    }
  }
};
</script>

<style scoped>
.result-ring {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  text-align: center;
}

.progress-circle {
  position: relative;
  margin-bottom: 10px;
}

.outer-ring {
  position: relative;
  box-sizing: border-box;
}

.inner-circle {
  position: absolute;
  background-color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.percentage {
  font-weight: bold;
  color: #222;
  font-family: 'Rajdhani', sans-serif;
}

h3 {
  margin: 5px 0;
  font-weight: bold;
  font-size: 18px;
}

p {
  margin: 5px 0;
  font-size: 14px;
}
</style>